import(/* webpackMode: "eager" */ "/home/runner/_work/voyager/voyager/apps/web-app/src/app/(invest)/invest/[slug]/page.tsx");
